const profiles = [

  {
    id: 1,
    name: 'Asish Raj Pandey',
    post: 'Protector',
    mobile: 'Mobile N/A',
    address: 'Kathmandu',
    photo: './assets/profiles/samrak.jpg',
    email: 'notavailable@gmail.com',
  },
  {
    id: 2,
    name: 'Lilanath Adhikari',
    post: 'Chairperson',
    mobile: '9841683737',
    address: 'Kathmandu',
    photo: './assets/profiles/cp.png',
    email: '',
  },

  {
    id: 3,
    name: 'Narayan Khatri',
    post: 'Vice Chairperson',
    mobile: '9841127970',
    address: 'Kathmandu',
    photo: './assets/profiles/nrk.jpg',
    email: 'notavailable@gmail.com',
  },
  {
    id: 4,
    name: 'Basudev Parajuli',
    post: 'Vice Chairperson',
    mobile: '9814000939',
    address: 'Chitwan',
    photo: './assets/profiles/p6.jpg',
    email: 'notavailable@gmail.com',
  },
  {
    id: 5,
    name: 'Praveen Bhusal(Paras)',
    post: 'Secretary',
    mobile: '9845330168',
    address: 'Rupandehi',
    photo: './assets/profiles/pb.jpg',
    email: 'notavailable@gmail.com',
  },
  {
    id: 6,
    name: 'Mahesh Rana',
    post: 'Youth Coordinator',
    mobile: '9767549394',
    address: 'Lamjung',
    photo: './assets/profiles/p5.jpg',
    email: 'notavailable@gmail.com',
  },
  {
    id: 7,
    name: 'Raju Thapa',
    post: 'Transport Dept. Head',
    mobile: '9866296473',
    address: 'Kathmandu',
    photo: './assets/profiles/p3.jpg',
    email: 'notavailable@gmail.com',
  },

  {
    id: 8,
    name: 'Pursottam Giri',
    post: 'Advisor',
    mobile: '984-9990123',
    address: 'Dang',
    photo: './assets/profiles/pur.jpg',
    email: 'notavailable@gmail.com',
  },

  {
    id: 9,
    name: 'Suresh Pardhe',
    post: 'Advisor',
    mobile: '9860187852',
    address: 'Dang',
    photo: './assets/profiles/pardhe.jpg',
    email: 'notavailable@gmail.com',
  },

  {
    id: 10,
    name: 'Rajesh Rana',
    post: 'Central member',
    mobile: '9823575708',
    address: 'Lamjung',
    photo: './assets/profiles/p4.jpg',
    email: 'notavailable@gmail.com',
  },

  {
    id: 11,
    name: 'Ghanashyam Bohora',
    post: 'Central member',
    mobile: '9849116845',
    address: 'Baitaidi',
    photo: './assets/profiles/p2.jpg',
    email: 'notavailable@gmail.com',
  },
  {
    id: 12,
    name: 'Kamal Karki',
    post: 'Central member',
    mobile: '9851345390',
    address: 'Gulmi',
    photo: './assets/profiles/kamalkarki.jpg',
    email: 'notavailable@gmail.com',
  },

  {
    id: 13,
    name: 'Dhirendra Saud',
    post: 'Central member',
    mobile: '976-1785027',
    address: 'Baitaidi',
    photo: './assets/profiles/dhi.jpg',
    email: 'notavailable@gmail.com',
  },

  {
    id: 14,
    name: 'Bibek Thapa',
    post: 'Child Chairperson',
    mobile: '9814000939',
    address: 'Kathmandu',
    photo: './assets/profiles/bibek.jpg',
    email: 'notavailable@gmail.com',
  },
  // Add more profiles as needed
];
export default profiles;
